/**
 * Precision Event Tracking in Freshpaint for all sites
 *
 * See documentation here:
 * https://docs.freshpaint.io/data-management/sources/precision-tracking
 *
 */

/**
 * Sends a Precision Tracking event to GA4 via Freshpaint
 *
 * @param (str) eventName
 * @param (obj) params Any additional values to send to FP
 *
 */
export const track_fp = function(eventName, params = {}) {
  const options = {
    '$options': {
      integrations: {
        All: false,
        "Google Analytics 4 Proxy::G-28M44ZK8EQ": true
      }
    }
  };
  const params_and_options = Object.assign(params, options);
  if(typeof(freshpaint) == "object") {
    freshpaint.track(
      eventName,
      params_and_options
    )
  }
}

/**
 * Tracks a link click on the website in GA4 via Freshpaint
 */
export const track_link = function(label, container) {
  const isDev = document.location.hostname.match('dev');
  container.addEventListener("click", function(event) {
    if(is_link(event)) {
      // Log to console to troubleshoot for dev
      if (isDev) { console.log(label); }
      track_fp(label, {
        'clicked_link': event.target.href,
        'clicked_text': event.target.text
      });
    }
  });
}

const is_link = function(event) {
  return event.target && event.target.nodeName == "A";
}

// Event Tracking for Global Navigation
const navs = [
  ['.utility-nav-wrapper', "Utility"],
  ['.main-nav', "Main (Desktop)"],
  ['.mobile-nav-menu', "Main (Mobile)"],
  ['.footer-header', "Footer (Header)"],
  ['.footer-desktop', "Footer"],
  ['.footer-boilerplate', "Footer (Boilerplate)"]
];

navs.forEach( function( nav ) {
  let container = document.querySelector(nav[0]);
  if(container) {
    track_link(
      "Navigation - " + nav[1] + " - Link Click",
      container
    );
  }
});
